import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Icon from './customButtonPsPasteIcon.svg';

export class CustomButtonPsPaste extends Plugin {
  init() {
    const editor = this.editor;

    // このプラグイン用の設定を取得
    const customButtonPsPasteConfig = editor.config.get('customButtonPsPaste');
    if (customButtonPsPasteConfig && customButtonPsPasteConfig.onClick) {
      editor.ui.componentFactory.add('customButtonPsPaste', () => {
        const button = new ButtonView();

        button.set({
          label: editor.t('ペースト'),
          icon: Icon,
          withText: true,
        });

        button.on('execute', () => {
          customButtonPsPasteConfig.onClick();
        });

        return button;
      });
    }
  }
}
